import { RecipeCollectionPreview } from '@/types';
import { Link } from '@inertiajs/react';
import { useLocalizedRoute } from '@/hooks/localizedRoute';
import { ProfileImage, RecipeCollectionImage } from '@/Components/Specific';
import { Trans, useTranslation } from 'react-i18next';
import { UI } from '@/Components/UI';

type RecipeCollectionCardProps = {
    collection: RecipeCollectionPreview;
}

export const RecipeCollectionCard = ({ collection }: RecipeCollectionCardProps) => {
    const { t } = useTranslation(['collections']);
    const { localizedRoute } = useLocalizedRoute();

    return (
        <div className={'@container'}>
            <Link
                className={'group size-full grid grid-rows-[min-content_auto] @md:grid-cols-2 @md:grid-rows-1 gap-2 rounded-2xl bg-surface-1 p-2 transition-all duration-200 hover:bg-secondary-container active:rounded-3xl'}
                href={localizedRoute('recipeCollections.show', { collection: collection.slug })}>
                <div className={'aspect-4/3'}>
                    <RecipeCollectionImage
                        itemClassName={'transition-all duration-200 group-active:rounded-2xl group-hover:bg-secondary/15'}
                        collection={collection} />
                </div>

                <div className={'flex flex-col justify-between gap-4'}>
                    <div className={'flex flex-col gap-1'}>
                        <UI.Heading
                            level={3}
                            className={'line-clamp-2 grow mt-0 text-lg text-on-surface group-hover:text-on-secondary-container'}>
                            {collection.title}
                        </UI.Heading>

                        <div
                            className={'flex flex-row items-center gap-1 text-on-surface text-opacity-60 group-hover:text-on-secondary-container'}>
                            <ProfileImage
                                user={collection.author} />

                            <span className={'line-clamp-1 text-ellipsis'}>
                                {collection.author.name}
                            </span>
                        </div>
                    </div>

                    <div
                        className={'flex flex-row justify-between text-on-surface text-opacity-60 group-hover:text-on-secondary-container'}>

                        <Trans
                            t={t}
                            i18nKey={'recipesCount'}
                            count={collection.recipesCount}
                            components={[
                                <UI.Number value={collection.recipesCount!} />
                            ]} />
                    </div>
                </div>
            </Link>
        </div>
    );
};
